export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/2cb37da391587709fd85749e116baa74.svg";